// extracted by mini-css-extract-plugin
module.exports = {"root":"subjects-id_root__6VTk1","introheader__content":"subjects-id_introheader__content___7BVX","root__aside":"subjects-id_root__aside__0oaIR"};